// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export function stringOrUndefined(data: any): string | undefined {
	return typeof data === 'string' ? data : undefined;
}
